import _ from 'lodash'

export default ({ calculations: { prices: { index: prices } } }) => ({
  ...prices,
  json: {
    currencies: _.reduce(
      prices.json.currencies,
      (acc, v, k) => ({ ...acc, [k]: { ...prices.json, coin_price: v } }),
      {}
    )
  }
})



// WEBPACK FOOTER //
// ./src/selectors/prices.js